import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b006cad0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "bill-detail-box" }
const _hoisted_3 = { class: "bill-detail-flex1" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 导出 ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "data-contianer" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("我要调账")
const _hoisted_7 = { style: {"margin":"0 8px","font-weight":"normal"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DefaultOptionSelect = _resolveComponent("DefaultOptionSelect")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_download_center = _resolveComponent("download-center")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ReportTable = _resolveComponent("ReportTable")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_AdminTableLayout = _resolveComponent("AdminTableLayout")!
  const _component_OrderTravel = _resolveComponent("OrderTravel")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AdminTableLayout, {
      formData: _ctx.formData,
      formLabelWidth: 100,
      searchDisabled: _ctx.loading,
      onSearch: _ctx.onSearchHandle
    }, {
      "search-info": _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_form_item, {
              "label-width": 100,
              label: "按运单号查询",
              prop: "billCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "bill-detail-input",
                  type: "textarea",
                  rows: 3,
                  placeholder: "支持运单号查询，多个运单号请用换行或英文逗号隔开，最多支持1000条搜索",
                  modelValue: _ctx.formData.billCode,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.billCode) = $event)),
                  onBlur: _ctx.deleteRepeatOrderNumber
                }, null, 8, ["modelValue", "onBlur"]),
                _createElementVNode("div", {
                  class: "bill-detail-box-clear",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.billCode = ''))
                }, " 清空 ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_row, { justify: "flex-start" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 11 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "费用类型",
                      prop: "itemCode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DefaultOptionSelect, {
                          disabled: !!_ctx.formData.billCode,
                          valueKey: "value",
                          labelKey: "key",
                          defaultOptions: _ctx.freeItem,
                          modelValue: _ctx.formData.itemCode,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.itemCode) = $event))
                        }, null, 8, ["disabled", "defaultOptions", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 11 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "费用子类",
                      prop: "dictCode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DefaultOptionSelect, {
                          disabled: !!_ctx.formData.billCode,
                          valueKey: "value",
                          labelKey: "key",
                          defaultOptions: _ctx.dictItem,
                          modelValue: _ctx.formData.dictCode,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.dictCode) = $event))
                        }, null, 8, ["disabled", "defaultOptions", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      "content-header": _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "system-btn",
          type: "primary",
          size: "mini",
          loading: _ctx.downloadLoading,
          disabled: _ctx.tableData.length <= 0,
          onClick: _ctx.handleExportAll
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"]),
        _createVNode(_component_download_center, { "is-inner": "" })
      ]),
      "content-table": _withCtx(() => [
        _hoisted_5,
        _createVNode(_component_ReportTable, {
          loading: _ctx.loading,
          tableData: _ctx.tableData,
          showTableColumn: _ctx.showTableColumn,
          isVirtualized: "",
          templateRenders: {
          billCode: _ctx.billCodeHandle,
          actions: _ctx.actionsCodeHandle,
        }
        }, {
          billCode: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              type: "primary",
              style: {"margin-right":"5px"},
              onClick: ($event: any) => (_ctx.handleClick(row.billCode))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.billCode), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          actions: _withCtx(({ row }) => [
            (_ctx.formData.status != 1)
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  type: "primary",
                  onClick: ($event: any) => (_ctx.handleReAccount(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "tableData", "showTableColumn", "templateRenders"])
      ]),
      "foot-pagination": _withCtx(() => [
        _createVNode(_component_el_pagination, {
          "popper-class": "pagination-popper",
          class: "system-pagination",
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.totalNum,
          "page-sizes": [..._ctx.pageSizeList, 1000, 2000, 5000],
          "current-page": _ctx.pageNum,
          "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageSize) = $event)),
          onCurrentChange: _ctx.currentPageChangeHandle,
          onSizeChange: _ctx.sizeChangeHandle
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_7, "第 " + _toDisplayString(_ctx.pageNum) + " 页", 1)
          ]),
          _: 1
        }, 8, ["total", "page-sizes", "current-page", "page-size", "onCurrentChange", "onSizeChange"])
      ]),
      _: 1
    }, 8, ["formData", "searchDisabled", "onSearch"]),
    _createVNode(_component_el_dialog, {
      title: "物流详情",
      modelValue: _ctx.dialog.visible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialog.visible) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_OrderTravel, {
          orderInfo: _ctx.dialog.orderInfo,
          "show-bill": "",
          loading: _ctx.dialog.loading
        }, null, 8, ["orderInfo", "loading"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}